module.exports = __webpack_public_path__ + "img/excavator-red.908802a7.svg";